import React, { useEffect } from 'react'
import useRingover from '../../hooks/useRingover'
import { Box } from '@material-ui/core'
import config from '../../config'
import { isInExtranet } from '../../utils'
import { useLocation } from 'react-router'

export const RingoverControl = () => {
  const location = useLocation()
  const { initRingover, hideRingover, showRingover, openRingoverFrame } =
    useRingover()

  useEffect(() => {
    if (!isInExtranet(location)) {
      setTimeout(() => {
        initRingover()
      }, 1000)
    }
  }, [initRingover, hideRingover])
  return (
    <Box
      style={{
        position: 'fixed',
        width: openRingoverFrame ? '380px' : '45px',
        height: openRingoverFrame ? '620px' : '45px',
        right: '5px',
        bottom: '25px',
        zIndex: 99999,
      }}
    >
      <Box>
        <Box id="iframe-ringover"></Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'end',
            justifyContent: 'end',
          }}
        >
          {openRingoverFrame && (
            <img
              style={{
                width: '45px',
                cursor: 'pointer',
              }}
              src={`${config.PUBLIC_URL}/img/icon-ringover.svg`}
              onClick={() => {
                if (open) {
                  hideRingover()
                } else {
                  showRingover()
                }
              }}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}
